import { useCallback, useMemo } from "react";

interface Props {
  message: string;
  lang?: string;
}

export default function useTextToSpeech({ message, lang }: Props) {
  const utterance = useMemo(() => {
    const inst = new SpeechSynthesisUtterance(message);
    inst.lang = lang ?? "zh-TW";
    inst.pitch = 1;
    inst.rate = 1;
    inst.volume = 1;
    return inst;
  }, [message]);

  const start = useCallback(() => {
    speechSynthesis.speak(utterance);
  }, [utterance]);
  const pause = useCallback(() => {
    speechSynthesis.pause();
  }, [utterance]);
  const stop = useCallback(() => {
    speechSynthesis.cancel();
  }, [utterance]);

  return {
    start,
    pause,
    stop,
  };
}
